import { SkillForm } from "@/core/skillForms/types";
import { createInitialPetitionSkillStep2 } from "../step2";

export const createCriminalInitialPetitionSkillForm: SkillForm = {
  skillId: "create_criminal_initial_petition",
  title: "Petição Inicial Criminal",
  steps: [createInitialPetitionSkillStep2],
  lastStepSubmitButtonText: "Criar Petição Inicial",
};
